import I18n from "../../i18n";

export default function modalElement(id,dimension,title):string{
    console.log(I18n.apply(title))
    return `
        <div class="modal-container d-none">
            <div id="${id}" class="modal ${dimension}">
                <div class="modal-header">
                    <h2 class="modal-title">${I18n.apply(title)}</h2>
                    <span class="modal-closer d-none">&times;</span>
                </div>
                <div class="modal-body">
                </div>
            </div>
        </div>
    `;
}